var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("legend", [_vm._v("Company Details")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.name,
                  expression: "formData.name",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "name",
                required: "",
                name: "companyName",
                placeholder: "Enter the name of the company here...",
              },
              domProps: { value: _vm.formData.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "name" } },
              [_vm._v("Name of company")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("companyName"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FileUpload", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { id: "logo", label: "Company logo", name: "logo" },
            model: {
              value: _vm.formData.logo.uuid,
              callback: function ($$v) {
                _vm.$set(_vm.formData.logo, "uuid", $$v)
              },
              expression: "formData.logo.uuid",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.website,
                  expression: "formData.website",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "name",
                required: "",
                name: "website",
                placeholder: "Enter the company website here...",
              },
              domProps: { value: _vm.formData.website },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "website", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "name" } },
              [_vm._v("Company Website")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("website"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FormControlRegion", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { label: "Region covered", name: "region" },
            model: {
              value: _vm.formData.region,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "region", $$v)
              },
              expression: "formData.region",
            },
          }),
          _vm._v(" "),
          _c("FormControlCountry", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { label: "Company HQ country", name: "hqCountry" },
            model: {
              value: _vm.formData.hqCountry,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "hqCountry", $$v)
              },
              expression: "formData.hqCountry",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.hqLocation,
                  expression: "formData.hqLocation",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "hq-location",
                name: "hqLocation",
                placeholder: "Enter a location...",
                required: "",
              },
              domProps: { value: _vm.formData.hqLocation },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "hqLocation", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "hq-location" } },
              [_vm._v("Company HQ location")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("hqLocation"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.hqAddressLine1,
                  expression: "formData.hqAddressLine1",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: `hq-address-line-1`,
                name: "hq_address_line_1",
                placeholder: "Enter Address Line 1...",
              },
              domProps: { value: _vm.formData.hqAddressLine1 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "hqAddressLine1", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: `hq-address-line-1` },
              },
              [_vm._v("Address Line 1")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.hqAddressLine2,
                  expression: "formData.hqAddressLine2",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: `hq-address-line-2`,
                name: "hq_address_line_2",
                placeholder: "Enter Address Line 2...",
              },
              domProps: { value: _vm.formData.hqAddressLine2 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "hqAddressLine2", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: `hq-address-line-2` },
              },
              [_vm._v("Address Line 2")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.hqAddressLine3,
                  expression: "formData.hqAddressLine3",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: `hq-address-line-3`,
                name: "hq_address_line_3",
                placeholder: "Enter Address Line 3...",
              },
              domProps: { value: _vm.formData.hqAddressLine3 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "hqAddressLine3", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: `hq-address-line-3` },
              },
              [_vm._v("Address Line 3")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.hqPhone,
                  expression: "formData.hqPhone",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: `hq-telephone`,
                name: "hq_telephone",
                placeholder: "Enter Telephone Number...",
              },
              domProps: { value: _vm.formData.hqPhone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "hqPhone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: `hq-telephone` } },
              [_vm._v("Telephone Number")]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.offices, function (office, index) {
            return [
              _c("hr"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: office.id,
                    expression: "office.id",
                  },
                ],
                attrs: { type: "hidden" },
                domProps: { value: office.id },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(office, "id", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "action",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showDeleteModal(office.uuid)
                    },
                  },
                },
                [
                  _c("svg", { staticClass: "svg-icon" }, [
                    _c("use", {
                      staticStyle: { fill: "#FF0000", stroke: "none" },
                      attrs: { "xlink:href": "#icon--delete" },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("FormControlCountry", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  id: `office-${index}-country`,
                  label: "Office country*",
                  name: "officeCountry",
                },
                model: {
                  value: office.country,
                  callback: function ($$v) {
                    _vm.$set(office, "country", $$v)
                  },
                  expression: "office.country",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: office.location,
                      expression: "office.location",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: `office-${index}-location`,
                    name: "officeLocation",
                    placeholder: "Enter a location...",
                    required: "",
                  },
                  domProps: { value: office.location },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(office, "location", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form__label",
                    attrs: { for: `office-${index}-location` },
                  },
                  [_vm._v("Office location*")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("officeLocation"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: office.address_line_1,
                      expression: "office.address_line_1",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: `office-${index}-address-line-1`,
                    name: "address_line_1",
                    placeholder: "Enter Address Line 1...",
                  },
                  domProps: { value: office.address_line_1 },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(office, "address_line_1", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form__label",
                    attrs: { for: `office-${index}-address-line-1` },
                  },
                  [_vm._v("Address Line 1")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: office.address_line_2,
                      expression: "office.address_line_2",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: `office-${index}-address-line-2`,
                    name: "address_line_2",
                    placeholder: "Enter Address Line 2...",
                  },
                  domProps: { value: office.address_line_2 },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(office, "address_line_2", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form__label",
                    attrs: { for: `office-${index}-address-line-2` },
                  },
                  [_vm._v("Address Line 2")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: office.address_line_3,
                      expression: "office.address_line_3",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: `office-${index}-address-line-3`,
                    name: "address_line_3",
                    placeholder: "Enter Address Line 3...",
                  },
                  domProps: { value: office.address_line_3 },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(office, "address_line_3", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form__label",
                    attrs: { for: `office-${index}-address-line-3` },
                  },
                  [_vm._v("Address Line 3")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: office.phone,
                      expression: "office.phone",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: `office-${index}-telephone`,
                    name: "telephone",
                    placeholder: "Enter Telephone Number...",
                  },
                  domProps: { value: office.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(office, "phone", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form__label",
                    attrs: { for: `office-${index}-telephone` },
                  },
                  [_vm._v("Telephone Number")]
                ),
              ]),
            ]
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--link",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.addOffice.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Add additional office")]
            ),
          ]),
          _vm._v(" "),
          _vm.type === "create"
            ? _c(
                "div",
                { staticClass: "form__group form__group--submit" },
                [
                  _c(
                    "router-link",
                    { staticClass: "btn", attrs: { to: { name: "members" } } },
                    [_vm._v("Back")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "wait",
                          rawName: "v-wait:disabled",
                          value: ["submit", "logo uploading"],
                          expression: '["submit", "logo uploading"]',
                          arg: "disabled",
                        },
                      ],
                      staticClass: "btn btn--primary",
                    },
                    [_vm._v("Save & Continue")]
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "form__group form__group--submit" },
                [
                  _c(
                    "router-link",
                    { staticClass: "btn", attrs: { to: `/members/${_vm.id}` } },
                    [_vm._v("Back")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "wait",
                          rawName: "v-wait:disabled",
                          value: ["submit", "logo uploading"],
                          expression: '["submit", "logo uploading"]',
                          arg: "disabled",
                        },
                      ],
                      staticClass: "btn btn--primary",
                    },
                    [_vm._v("Update Member")]
                  ),
                ],
                1
              ),
        ],
        2
      ),
      _vm._v(" "),
      _c("v-dialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }